import {TranscriptionSearchViewer} from './transcription_search_viewer'

/*
  This is displayed in call details as an icon the user clicks on to view 
  the transcription with search field view.
*/
export class TranscriptionSearchViewerIcon extends HTMLElement {
  constructor() {
    super();

    this.callid = this.getAttribute("callid");
    this.domain_id = this.getAttribute("domain_id");
    this.src = this.getAttribute("src");
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const hiddenContainer = document.querySelector('.report-details-container');
    if (hiddenContainer){
      hiddenContainer.classList.add('hidden');
      let view = new TranscriptionSearchViewer(hiddenContainer, this.callid, this.src, this.domain_id);
      hiddenContainer.parentElement.appendChild(view);
    }
  }

  connectedCallback() {
    this.innerHTML = `
      <i 
        class="fa fa-file-text-o fa-lg view_transcription" 
        title="Click to view transcription with search field"
        style="margin-left:6px;"
        data-callid="${this.callid}"
      ></i>

    `;

    this.addEventListener("click", this.handleClick);
  }

}


customElements.define("transcription-search-viewer-icon", TranscriptionSearchViewerIcon);
